import { Sitemap } from "@iventis/domain-model/model/sitemap";
import { SitemapVersion } from "@iventis/domain-model/model/sitemapVersion";
import { SitemapVersionLevelCreateResponse } from "@iventis/domain-model/model/sitemapVersionLevelCreateResponse";
import { MapObjectSitemapLevelReassignmentPayload } from "@iventis/domain-model/model/mapObjectSitemapLevelReassignmentPayload";
import { SitemapVersionLevel } from "@iventis/domain-model/model/sitemapVersionLevel";
import { SitemapVersionLevelCadConfig } from "@iventis/domain-model/model/sitemapVersionLevelCadConfig";
import { createContext, useContext } from "react";
import { CadStyle } from "@iventis/cad-georeferencer/src/types/style";
import { Asset } from "@iventis/domain-model/model/asset";
import { SitemapVersionLevelWithFiles } from "../sitemap-types";

export interface ISitemapApiContext {
    getSitemap: (sitemapId: string) => Promise<Sitemap>;
    createSitemap: (sitemap: Sitemap) => Promise<Sitemap>;
    updateSitemap: (sitemap: Sitemap) => Promise<Sitemap>;
    reassignSitemapLevels: (reassignment: Omit<MapObjectSitemapLevelReassignmentPayload, "projectId">[]) => Promise<void>;
    getSitemapVersion: (sitemapId: string, sitemapVersionId: string) => Promise<SitemapVersion>;
    createSitemapVersion: (sitemapVersion: SitemapVersion) => Promise<SitemapVersion>;
    updateSitemapVersion: (sitemapVersion: SitemapVersion) => Promise<SitemapVersion>;
    deleteSitemapVersion: (id: string, sitemapId: string) => Promise<void>;
    getSitemapVersionLevel: (sitemapId: string, sitemapVersionId: string, sitemapVersionLevelId: string) => Promise<SitemapVersionLevel>;
    getSitemapVersionLevelCadConfig: (sitemapId: string, sitemapVersionId: string, sitemapVersionLevelId: string) => Promise<SitemapVersionLevelCadConfig>;
    createSitemapVersionLevel: (sitemapVersionLevel: SitemapVersionLevelWithFiles, sitemapId: string) => Promise<SitemapVersionLevelCreateResponse>;
    updateSitemapVersionLevel: (sitemapVersionLevel: SitemapVersionLevelWithFiles, sitemapId: string) => Promise<string>;
    deleteSitemapVersionLevel: (id: string, sitemapVersionId: string, sitemapId: string) => Promise<void>;
    getSitemapVersionLevelCadFiles: (sitemapId: string, sitemapVersionId: string, sitemapVersionLevelId: string) => Promise<{ style: CadStyle }>;
    getMapBackgrounds: () => Promise<Asset[]>;
    getSitemapVersionLevelAsset: (levelId: string) => Promise<Asset>;
    copySitemapVersion: (sourceProjectId: string, sourceSitemapVersionId: string, destinationProjectId: string, destinationSitemapVersionId: string) => Promise<void>;
}

export const SitemapApiContext = createContext<ISitemapApiContext>(null);

export const useSitemapApiContext = () => useContext(SitemapApiContext);
